import { render, staticRenderFns } from "./indeicator_field_config.vue?vue&type=template&id=4abb8508&scoped=true"
import script from "./indeicator_field_config.vue?vue&type=script&lang=js"
export * from "./indeicator_field_config.vue?vue&type=script&lang=js"
import style0 from "./indeicator_field_config.vue?vue&type=style&index=0&id=4abb8508&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abb8508",
  null
  
)

export default component.exports